import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { PrintableFormatImageLinkContainerModel } from '../../../../../models/aggregates/print';
import { Core2Config } from '../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class PrintableFormatImageLinkService extends BaseApiTemplateService<PrintableFormatImageLinkContainerModel> {

  readonly subUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PRINT_PREFIX + 'printable-format/image-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.subUrl;
    this.endpoint_path = this.subUrl;
    this.httpClient = http;
  }
}
